import { GET } from 'utils/requests.utils'

const BASE_URL = '/common/shop_name'

export const generateShopName = (params) => GET(BASE_URL, params)
